<template>
  <div  :data-theme="theme" class="MarketHeader">
    <div class="marketHeader_left" >
      <a target="_blank" :href="urls.home">
        <img src="https://resource.fx994.com/images/home/new-logo-white.svg" class="marketHeader_headerLogo" alt="" v-if="theme==='dark'&&local==='zh-cn'">
        <img src="https://resource.fx994.com/images/home/new-logo-black.svg" class="marketHeader_headerLogo" alt="" v-if="theme==='light'&&local==='zh-cn'">
        <img src="https://resource.fx994.com/images/home/new-logo-white.svg" class="marketHeader_headerLogo" alt="" v-if="theme==='dark'&&local==='zh'">
        <img src="https://resource.fx994.com/images/home/new-logo-black.svg" class="marketHeader_headerLogo" alt="" v-if="theme==='light'&&local==='zh'">
        <img src="../../assets/market/bitlogo_light_en.svg" class="marketHeader_headerLogo" alt="" v-if="theme==='dark'&&local!=='zh-cn'&&local!=='zh'">
        <img src="../../assets/market/bitlogo_dark_en.svg" class="marketHeader_headerLogo" alt="" v-if="theme==='light'&&local!=='zh-cn'&&local!=='zh'">
      </a>
      
      <a  class="marketHeader_navItem" target="_blank" :href="urls.home">{{$t('9112')}}</a>
      <a class="marketHeader_navItem" target="_blank" :href="urls.dr">{{$t('9113')}}</a>
      <a class="marketHeader_navItem" target="_blank" :href="urls.dy">{{$t('31321')}}</a>
      <a class="marketHeader_navItem" target="_blank" :href="urls.pr">{{$t('9115')}}</a>
      <a class="marketHeader_navItem" target="_blank" :href="urls.tk">{{$t('9114')}}</a>
      <a class="marketHeader_navItem" target="_blank" :href="urls.lv">{{$t('31322')}}</a>
      <a class="marketHeader_navItem" target="_blank" :href="urls.ex">{{$t('9117')}}</a> 
      <a class="marketHeader_navItem" target="_blank" :href="urls.ma">{{$t('9118')}}</a>
      <div class="marketHeader_ellipsisLi">
        <span class="marketHeader_middleLine">
          
        </span>
        <div class="marketHeader_ellipsisBox">
          <!-- 数据中心 -->
          <li> 
            <a target="_blank" :href="urls.data">{{$t('14002')}}</a>
          </li>
          <!-- 实勘 -->
          <li>
            <a target="_blank" :href="urls.su">{{$t('9116')}}</a>
          </li>
          <!-- 资讯 -->
          <li>
            <a target="_blank" :href="urls.news">{{$t('9124')}}</a>
          </li>
          <!-- 教育 -->
          <li>
            <a target="_blank" :href="urls.ed">{{$t('31323')}}</a>
          </li>
          <!-- 评论 -->
          <li>
            <a target="_blank" :href="urls.co">{{$t('31324')}}</a>
          </li>
          <!-- 公告 -->
          <li>
            <a target="_blank" :href="urls.no">{{$t('9121')}}</a>
          </li>
          <!-- 日历 -->
          <li>
            <a target="_blank" :href="urls.ca">{{$t('9122')}}</a>
          </li>
          <!-- 快讯 -->
          <li>
            <a target="_blank" :href="urls.live">{{$t('9123')}}</a>
          </li>
          <!-- 书城 -->
          <!-- <li>
            <a target="_blank" :href="urls.book">{{$t('14003')}}</a>
          </li> -->
        

        </div>
      </div>
    </div>
    <div class="marketHeader_right">
     
      <div class="select-wrap" >
        <a-select
          :dropdownMenuStyle="{ backgroundColor: theme==='dark'?'#202F44':'#ffffff' }"
          ref="select"
          style="width: 120px"
          :defaultValue="lang"
          @change="handleChange"
          optionFilterProp="children"
         >
         <!-- placeholder="中文(简体)" -->

          <a-select-option :data-theme="theme" v-for="item in options" :key="item.value" :value="item.lang">
            {{ item.text }}
          </a-select-option>
        </a-select>
      </div>

        <div class="marketHeader_switch marketHeader_right_item">
          <a-switch :checked="checked" @change="changeSwitch">
            <template #checkedChildren>
              <img src="../../assets/icons/svg/moon.svg" alt="">
            </template>
            <template #unCheckedChildren>
              <img src="../../assets/icons/svg/sun.svg" alt="">
              
            </template>
          </a-switch>
        </div>
        <div class="marketHeader_right_item lineColorBox">
          <span class="marketHeader_lineBtn">
            <span>
              <img src="../../assets/icons/svg/kline-up-cn.svg" alt="" v-show="upDown===0">
              <img src="../../assets/icons/svg/kline-up-en.svg" alt="" v-show="upDown===1">
            </span>
          </span>
          <span class="marketHeader_lineToggle" @click="changeUpDown">
            <span>
              <img src="../../assets/icons/svg/kline-toggle-dark.svg" alt="" v-if="theme==='dark'">
              <img src="../../assets/icons/svg/kline-toggle-light.svg" alt="" v-if="theme==='light'">
            </span>
          </span>
          <span class="marketHeader_lineBtn">
            <span>
              <img src="../../assets/icons/svg/kline-down-cn.svg" alt="" v-show="upDown===0">
              <img src="../../assets/icons/svg/kline-down-en.svg" alt="" v-show="upDown===1">
            </span>
          </span>
        </div>
        <div class="marketHeader_right_item">
          <a target="_blank" :href="urls.dl" class="download">
          <span>
            <img src="../../assets/icons/svg/dwl-icon.svg" class="marketHeader_headerLogo" alt="">
          </span>
          <span>
            {{$t('9125')}}
          </span>
        </a>
        </div>
    </div>
  </div>
</template>

<script>
// import {setToken,getToken} from '../utils/auth'
// import {USER_Home} from '../api/user'
import { mapState, mapActions, mapGetters } from 'vuex';
import {  getSuffix} from "@/utils/baseFn/filter";
export default {
inject:['reload'],
name: 'Home',
data() {
  return {
    value:{},
    checked:localStorage.getItem('skin')!=='light',
    lang:'en',
    urls:{},
    options:[
      {
        lang: "zh-cn",
        value: "zh-cn",
        text: '简体中文'
      },
      {
        lang: 'zh',
        value: 'zh',
        text: '繁体中文',
      },
      {
        lang: "en",
        value: "en",
        text: 'English'
      },
      // {
      //   lang: "ko",
      //   value: "ko",
      //   text: '한국어'
      // },
      {
        lang: "ja",
        value: "ja",
        text: '日本語',
      },
      {
        lang: "vi",
        value: "vi",
        text: 'Tiếng Việt',
      },
      {
        lang: 'id',
        value: 'id',
        text: 'Indonesia'
      }
    ]
  }
},
computed: {
...mapState(['local','theme','upDown','quoteAsset','TokenCode']),
...mapGetters(['getTokenCode'])
},
watch:{
  local:{
    immediate:true,
    handler(e){
      this.setLocal({local:e})
      // this.lang=newdata
  }
  }
},  
created() {
  let local=location.href.split('/')[3]
  if(local!=='zh'&&local!=='zh-cn'&&local!=='en'&&local!=='ja'&&local!=='vi'&&local!=='id'){
    local='en'
  }
  this.lang=local
  // this.$i18n.locale=this.local
  this.setTheme({theme:localStorage.getItem('skin')||'dark'})
  this.urls={
      home:`https://www.wikibit.com/${this.lang}`,
      dr:`https://www.wikibit.com/${this.lang}/dr.html`,
      tk: `https://www.wikibit.com/${this.lang}/tk.html`,
      pr: `https://www.wikibit.com/${this.lang}/pr.html`,
      kline: `https://q.wikibit.com/${this.lang}/`,
      ma: `https://market.wikibit.com/${this.lang}/all/1.html`,
      su: `https://survey.wikibit.com/${this.lang}/`,
      no: `https://notice.wikibit.com/${this.lang}/bulletin.html`,
      ca: `https://calendar.wikibit.com/${this.lang}/index.html`,
      live: `https://live.wikibit.com/${this.lang}/7x24.html`,
      news: `https://www.wikibit.com/${this.lang}/news.html`,
      ex: `https://exposure.wikibit.com/${this.lang}/revelation.html`,
      // gray: `https://data.wikibit.com/${this.lang}/gray.html`,
      data: `https://data.wikibit.com/${this.lang}/index.html`,
      ed: `https://www.wikibit.com/${this.lang}/education/new/1.html`, // 教育
      co: `https://www.wikibit.com/${this.lang}/exchanges/commentsList`, // 评论
      dy: `https://www.wikibit.com/${this.lang}/dynamic/index.html`, // 社区
      lv: `https://www.wikibit.com/${this.lang}/liveroom`, // 直播
      dl: `https://www.wikibit.com/${this.lang}/download.html`,
    }
  
},
methods: {
  ...mapActions(['setLocal','setTheme','setUpDown']),
  changeSwitch(){
    this.checked=!this.checked
    if(!this.checked){
      this.setTheme({theme:'light'})
      localStorage.setItem('skin','light')
    }else{
      this.setTheme({theme:'dark'})
      localStorage.setItem('skin','dark')
    }
    this.reload()
  },  
  changeUpDown(){
    this.setUpDown({upDown:this.upDown?0:1})
    this.reload()

  },  
  handleChange(e){
    this.$i18n.locale=e
    this.setLocal({local:e})
    if(this.TokenCode==''){
      window.location.href = `/${e}/market/`;
    }else{
      window.location.href = `/${e}/market/${this.quoteAsset}/${this.TokenCode}.html`;
    }
    // this.reload()
  }
},
}
</script>

<style lang="less">
.MarketHeader{
  background-size: cover;
  user-select: none;
    display: flex;
    justify-content: space-between;
    padding: 11px 24px;
    height: 56px;
    background: var(--grey800);
    // background-color: @grey800;
   .marketHeader_headerLogo{
    display: block;
    margin: 3px 0;
    height: 30px;
    border-radius: 6px;
    overflow: hidden;
   }
    .marketHeader_left{
      display: flex;
      .marketHeader_navItem{
      margin-left: 30px;
       font-size: 16px;
       color: var(--grey200);
       line-height: 34px;
      }
      .marketHeader_ellipsisLi{

      width: 28px;
      height: 34px;
      margin-left: 30px;
      position: relative;
      cursor: pointer;
      &:hover {
        &:before {
          background: #e66112;
        }
        &:after {
          background: #e66112;
          width: 18px;
        }
        & .marketHeader_middleLine {
          background: #e66112;
        }
        & .marketHeader_ellipsisBox {
          display: block;
        }
      }

    &:before {
      position: absolute;
      content: "";
      top: 9px;
      right: 5px;
      width: 18px;
      height: 2px;
      border-radius: 1;
      overflow: hidden;
      background: rgba(167, 173, 180, 0.5);
      transition: background 0.3s;
    }
    &:after {
      content: "";
      position: absolute;
      top: 23px;
      right: 5px;
      width: 10px;
      height: 2px;
      overflow: hidden;
      background: rgba(167, 173, 180, 0.5);
      transition-duration: 0.3s, 0.3s;
      transition-property: width, background;
    }
    & .marketHeader_middleLine {
      position: absolute;
      top: 16px;
      right: 5px;
      width: 18px;
      height: 2px;
      background: rgba(167, 173, 180, 0.5);
      border-radius: 1px;
      transition: background-color 0.3s;
    }
    .marketHeader_ellipsisBox{
      display: none;
      position: absolute;
      top: 34px;
      left: 14px;
      padding-top: 4px;
      transform: translateX(-50%);
      background: none;
      z-index: 14px;
      overflow: hidden;
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
      z-index: 9999;
        li{
          display: block;
          height: 50px;
          padding: 0 15px;
          white-space: nowrap;
          line-height: 50px;
          background: var(--kSelectBg);
          box-sizing: content-box;
        &:first-child {
          padding-top: 20px;
          border-radius: 5px 5px 0 0;
        }
        &:last-child {
          padding-bottom: 20px;
          border-radius: 0 0 5px 5px;
        }
        & a {
          display: block;
          padding: 0 15px;
          color: var(--kOptionColor);
          border-radius: 5px;
          &:hover {
            background: var(--kOptionHover);
          }
        }
          
          // a{
          //   display: block;
          //   padding: 0 15px;
          //   color: #c2c3c3;
          //   border-radius: 5px;
          //   &:hover {
          //   background: #575858;
          // }
          // }
        }
      }
    }
  }
    .marketHeader_right{
      display: flex;
      .select-wrap{
        .ant-select {
          min-width: 110px;
          font-size: 14px;
          color: #B0BFDB;
          background: var(--paperBg);
            // .ant-select-item {
            //   color: @grey200;
            //   &:hover {
            //     background: @grey900;
            //   }
            // }
          &:hover {
          border: 1px solid #ffc300;
          
        }
       }
        .ant-select-selection--single {
          background-color: var(--grey800);
          border-color: var(--grey500);
          width: 100%;
          height: 100%;
       }
 
        .ant-select-arrow {
         color: var(--grey200);
       }

      }
      

      
 
      .marketHeader_switch{
        width: 44px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        font-size: 16px;
        .ant-switch{
        background-color: var(--active);
          // line-height: 1.6rem;
        }
        .ant-switch-inner{
          display: block;
          // color: #fff;
          transition: margin 0.2s;
        }
        img{
          vertical-align: -0.25em;
        }
      }
      .marketHeader_right_item{
        margin-left: 28px;

        .download {
          display: flex;
          padding: 0 16px;
          height: 34px;
          font-size: 14px;
          line-height: 34px;
          white-space: nowrap;
          border: 1px solid rgba(255, 255, 255, 0.2);
          box-sizing: border-box;
          box-shadow: 0px 0px 0px 1px #e66112;
          border-radius: 2px;
          background: linear-gradient(180deg, #e65c17 0%, #e66d17 100%);
          user-select: none;
          span{
            color: #fff;
          }
          img {
            display: block;
            margin: 9px 4px 9px 0;
            width: 10px;
            height: 16px;
          }
        }
      }
      .lineColorBox{
        display: flex;
        height: 34px;
        background: var(--kToggleBg);
        border: 1px solid;
        border-color: var(--kbd);
        border-radius: 2px;
        .marketHeader_lineBtn{
          display: flex;
          justify-content: center;
          align-items: center;
          width: 34px;
        }
        .marketHeader_lineToggle{
          margin: 3px 0;
          width: 26px;
          height: 26px;
          background: var(--kToggleBg);
          padding-top: 0.15em;
          cursor: pointer;
          img{
            width: 1em;
            height: 1em;
            vertical-align: -0.15em;
            overflow: hidden;
          }
        }
      }
    }
    
  }
  .ant-select-dropdown-menu {
     text-align: left;
    //  background: var(--paperBg);
    //  background-color: #202F44;
     font-size: 22px;
   }
      .ant-select-dropdown-menu-item {
        color: var(--grey200);
      }
      .ant-select-dropdown-menu-item:hover {
        background: var(--grey900) !important;
      }
      .ant-select-dropdown-menu-item-selected {
        background: var(--grey900) !important;

      }
      .ant-select-dropdown-menu-item-active {
        background: var(--grey900) !important;

      }
</style>